import React, { useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIData, JSXUIDebugTemplate } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import CoreGeneralButton from '../../core-general-button';

import "./core-debug-uis-window.css"

const CoreDebugUIsWindow = (props: CoreDebugUIsWindowConfig) => {
	return (
		<div className='core-debug-ui-uis-window core-debug-ui-general-window'>
			<div className='core-debug-ui-back-bttn'>
				<CoreGeneralButton width='100%'
					height='100%'
					onClick={props.onBackToMainWindowClicked}
					onRenderContent={() => {
						return (
							<p className='small-text center-element'>{'Back to Main Window'}</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={'Back to Main Window'}></CoreGeneralButton>
			</div>

			<div className='core-debug-ui-general-window' style={{ width: '900px', height: '900px', 'overflow': 'auto' }}>
				{props.gameManager.UiManager._uis.map((ui: UI, uiIndex: number) => {
					return (
						<div key={Tools.generateGuid()} style={{
							marginTop: '10px'
						}}>
							{(ui.uiData as JSXUIData).debugUITemplate ? <CoreGeneralButton width='100%'
								height='50px'
								onClick={() => {
									if (typeof ui.uiData['_isUiDataExpanded'] === undefined) {
										ui.uiData['_isUiDataExpanded'] = false;
									}
									ui.uiData['_isUiDataExpanded'] = !ui.uiData['_isUiDataExpanded'];
									props.setForceUpdate();
								}}
								onRenderContent={() => {
									return (
										<p className='small-text center-element'>{ui.name}</p>
									)
								}}
								isSelected={false}
								isDisabled={false}
								ariaLabel={ui.name}></CoreGeneralButton> : (null)}
							{ui.uiData['_isUiDataExpanded'] ? (ui.uiData as JSXUIData).debugUITemplate.map((debugTemplate: JSXUIDebugTemplate, debugTemplateIndx: number) => {
								return (
									<div key={Tools.generateGuid()} style={{
										width: '50%',
										position: 'relative',
										height: '50px',
										left: '10%'
									}}>
										<CoreGeneralButton width='100%'
											height='50px'
											style={{ backgroundColor: 'rgba(255,255,255,0.7' }}
											onClick={() => {
												var mockData = {...debugTemplate.debugUITemplate()};//generateMockDataFromTemplate((ui.uiData as JSXUIData).debugUITemplate());
												props.gameManager.UiManager.createUIInstance(ui.name, mockData);
												Tools.forceRerenderUI(ui.name);
												props.onUISpawned()
												props.setForceUpdate();
											}}
											onRenderContent={() => {
												return (
													<p className='small-text center-element'>{debugTemplate.name}</p>
												)
											}}
											isSelected={false}
											isDisabled={false}
											ariaLabel={debugTemplate.name}></CoreGeneralButton>
									</div>
								);

							}) : (null)}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export interface CoreDebugUIsWindowConfig {
	showWindowBackground: boolean;
	gameManager: GameManager;
	onBackToMainWindowClicked: () => void;
	onUISpawned: () => void;
	setForceUpdate: () => void;
}

export default CoreDebugUIsWindow;